import { type ReactNode, createContext, useContext, useMemo } from 'react'
import type { Address, Chain } from 'viem'
import { useConnection } from 'wagmi'
import type { Connector } from 'wagmi'

interface AccountContextProps {
  account: Address | undefined
  chain: Chain | undefined
  chainId: Chain['id'] | undefined
  isConnected: boolean | undefined
  connector: Connector | undefined
}

const AccountContext = createContext<AccountContextProps>({
  account: undefined,
  chain: undefined,
  chainId: undefined,
  isConnected: undefined,
  connector: undefined,
})

interface AccountProviderProps {
  children: ReactNode
}

export const AccountProvider = ({ children }: AccountProviderProps) => {
  const { address, chain, chainId, isConnected, connector } = useConnection()

  const value = useMemo(
    () => ({
      account: address,
      chain,
      chainId,
      isConnected,
      connector,
    }),
    [address, chain, chainId, isConnected, connector]
  )

  return <AccountContext.Provider value={value}>{children}</AccountContext.Provider>
}

export const useAccountContext = () => {
  const context = useContext(AccountContext)
  if (!context) {
    throw new Error('useAccountContext must be used within an AccountProvider')
  }
  return context
}
